import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { UserPreferences } from '../../types.tsx';

export const getUserPreferencesQuery = (keys: string[]) => `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [${keys.map((key) => `"${key}"`).join(', ')}])
}
`;

type ApiResult = {
	data: {
		myPreferences: Record<string, string | null>;
	};
};

export const getUserPreferences = async (keys: string[]): Promise<UserPreferences> => {
	try {
		const apiResult: ApiResult = await performPostRequest('/rest/gira/1/', {
			body: JSON.stringify({
				query: getUserPreferencesQuery(keys),
			}),
		});

		return apiResult.data.myPreferences;
	} catch (error) {
		fireErrorAnalytics({
			error: error instanceof Error ? error : undefined,
			meta: {
				id: 'getUserPreferences',
				packageName: 'jiraAdminPagesWorkflowsUserPreferences',
				teamName: 'Helix',
			},
		});

		throw error;
	}
};
